import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Cake } from "lucide-react";
import { toast } from "sonner";

const todayMMDD = () => {
  const d = new Date();
  return `${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export function BirthdayBox({ user, onUserUpdate }) {
  const { t } = useLanguage();
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);
  const isBirthday = user?.birthday && user.birthday === todayMMDD();

  const save = async () => {
    if (!value) return;
    setSaving(true);
    try {
      const r = await api.put("/me/birthday", { birthday: value.slice(5) });
      onUserUpdate(r.data);
      toast.success(t("birthday_saved"));
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  if (isBirthday) {
    return (
      <div data-testid="birthday-today" className="mt-4 bg-amber-50 border-2 border-amber-300 rounded-2xl p-4 flex items-center gap-3">
        <Cake className="w-8 h-8 text-[#D97706] shrink-0" />
        <div>
          <p className="font-heading font-bold text-[#4A2C2A]">{t("birthday_today_title")}</p>
          <p className="text-sm text-[#786C66]">{t("birthday_today_desc")}</p>
        </div>
      </div>
    );
  }

  if (user?.birthday) {
    const [m, d] = user.birthday.split("-");
    return (
      <p data-testid="birthday-set" className="mt-4 text-xs text-[#786C66] flex items-center gap-1.5">
        <Cake className="w-3.5 h-3.5 text-[#D97706]" /> {t("birthday_label")}: {d}/{m} · {t("birthday_bonus_hint")}
      </p>
    );
  }

  return (
    <div data-testid="birthday-box" className="mt-4 bg-white border border-[#E8DFD5] rounded-2xl p-4">
      <p className="text-sm font-semibold text-[#1F1615] flex items-center gap-1.5"><Cake className="w-4 h-4 text-[#D97706]" /> {t("birthday_prompt")}</p>
      <p className="text-xs text-[#786C66] mt-0.5">{t("birthday_bonus_hint")}</p>
      <div className="flex gap-2 mt-3">
        <Input data-testid="birthday-input" type="date" value={value} onChange={(e) => setValue(e.target.value)} className="bg-white border-[#E8DFD5] h-9" />
        <Button data-testid="save-birthday-btn" size="sm" disabled={!value || saving} onClick={save} className="rounded-full bg-[#4A2C2A] hover:bg-[#36201F] text-[#FDFBF7] h-9">
          {t("save")}
        </Button>
      </div>
    </div>
  );
}
